<div class="pt-2">
    <h2 mat-dialog-title class="flex items-center justify-between">
        <span>{{ 'auth.change_password.title' | transloco }}</span>
        <button mat-icon-button (click)="close()">
            <mat-icon class="icon-size-5">close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content>
        @if (alert) {
            <fuse-alert
                class="mb-4"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type">
                {{ alert.message }}
            </fuse-alert>
        }

        <form [formGroup]="form" class="flex flex-col gap-1">
            <mat-form-field class="w-full">
                <mat-label>{{ 'auth.change_password.old_password' | transloco }}</mat-label>
                <input matInput [type]="showOldPassword ? 'text' : 'password'" formControlName="oldPassword" />
                <button mat-icon-button matSuffix (click)="showOldPassword = !showOldPassword" type="button">
                    <mat-icon class="icon-size-5">{{ showOldPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="w-full">
                <mat-label>{{ 'auth.change_password.new_password' | transloco }}</mat-label>
                <input matInput [type]="showNewPassword ? 'text' : 'password'" formControlName="password" />
                <button mat-icon-button matSuffix (click)="showNewPassword = !showNewPassword" type="button">
                    <mat-icon class="icon-size-5">{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                @if (form.get('password').hasError('minlength') && form.get('password').touched) {
                    <mat-error>{{ 'auth.change_password.min_length' | transloco }}</mat-error>
                }
            </mat-form-field>

            <mat-form-field class="w-full">
                <mat-label>{{ 'auth.change_password.confirm_password' | transloco }}</mat-label>
                <input matInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" />
                <button mat-icon-button matSuffix (click)="showConfirmPassword = !showConfirmPassword" type="button">
                    <mat-icon class="icon-size-5">{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions class="flex justify-end px-6 pb-4">
        <button mat-stroked-button (click)="close()">
            {{ 'general.cancel' | transloco }}
        </button>
        <button
            mat-flat-button
            color="primary"
            [disabled]="submitting"
            (click)="submit()">
            @if (!submitting) {
                {{ 'auth.change_password.submit' | transloco }}
            } @else {
                <mat-progress-spinner [diameter]="20" [mode]="'indeterminate'"></mat-progress-spinner>
            }
        </button>
    </mat-dialog-actions>
</div>
